import request from '@/axios/requestDelivery'

// ====================岳辉==========================
// C-工地巡检-01-获取巡检中列表
export function getInspectionList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/getInspectionList',
    method: 'post',
    data
  })
}

// C-工地巡检-02-获取巡检详情
export function getInspectionInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/getInspectionInfo',
    method: 'post',
    data
  })
}

// C-工地巡检-03-添加日常巡检
export function saveDailyInspection(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/saveDailyInspection',
    method: 'post',
    data
  })
}

// C-工地巡检-04-添加节点巡检
export function saveNodeInspection(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/saveNodeInspection',
    method: 'post',
    data
  })
}

// C-工地巡检-05-(未巡检)节点巡检文案
export function getArticles(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/getArticles',
    method: 'post',
    data
  })
}

// C-工地巡检-06-创建整改
export function addComplaint(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/addComplaint',
    method: 'post',
    data
  })
}

// C-工地巡检-09-竣工仪式详情
export function completionDetail(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/completionDetail',
    method: 'post',
    data
  })
}

// C-工地巡检-10-删除巡检草稿副本
export function delInspectionDraft(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/delInspectionDraft',
    method: 'post',
    data
  })
}

// C-工地巡检-11-日常巡检(节点+草稿)
export function dailyInspectionDraftInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/dailyInspectionDraftInfo',
    method: 'post',
    data
  })
}

// C-工地巡检-08-创建竣工仪式
export function addCompletionCeremony(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/addCompletionCeremony',
    method: 'post',
    data
  })
}

// ====================晋枫==========================
/**
 * 公共接口-获取巡检相关节点播报详情
 * @method getInspectionArticle
 * @param {Object} data
 * @param {Object} data.article_info 节点信息
 * @param {String} data.article_info.order_id 订单ID
 * @param {String} data.article_info.article_id 巡检节点ID 开工仪式(100) 竣工仪式(120)
 * @return {Promise} 异步返回
 */
export function getInspectionArticle(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/article/getInspectionArticle',
    method: 'post',
    data
  })
}
/**
 * 公共接口-获取施工相关节点播报详情
 * @method getNodeArticle
 * @param {Object} data
 * @param {Object} data.article_info 节点信息
 * @param {String} data.article_info.order_id 订单ID
 * @param {String} data.article_info.article_id 巡检节点ID 开工仪式(100) 竣工仪式(120)
 * @return {Promise} 异步返回
 */
export function getNodeArticle(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/article/getNodeArticle',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-01-获取待交底列表
 * @method getDiscloseList
 * @param {Object} data
 * @param {Object} data.pagination 分页参数
 * @param {Number | String} data.pagination.page 分页页数
 * @param {Number | String} data.pagination.count 分页大小
 * @param {Object} data.filter 过滤参数
 * @param {String} data.filter.customer_name 客户名称过滤参数
 * @param {String} data.filter.customer_phone 客户电话过滤参数
 * @return {Promise} 异步返回
 */
export function getDiscloseList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getDiscloseList',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-02-获取待交底详情
 * @method getDiscloseInfo
 * @param {Object} data
 * @param {Object} data.order_info 订单信息
 * @param {String} data.order_info.order_id 订单ID
 * @return {Promise} 异步返回
 */
export function getDiscloseInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getDiscloseInfo',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-03-获取排期方案
 * @method getSchedulingInfo
 * @param {Object} data
 * @param {Object} data.order_info 订单信息
 * @param {String} data.order_info.order_id 订单ID
 * @return {Promise} 异步返回
 */
export function getSchedulingInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getSchedulingInfo',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-04-交底计划提交
 * @method saveDiscloseInfo
 * @param {Object} data
 * @param {Object} data.order_info 订单信息
 * @param {String} data.order_info.order_id 订单ID
 * @return {Promise} 异步返回
 */
export function saveDiscloseInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/saveDiscloseInfo',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-05-发布开工播报
 * @method orderStartBroadcast
 * @param {Object} data
 * @param {Object} data.order_info 订单信息
 * @param {String} data.order_info.order_id 订单ID
 * @param {String} data.order_info.content 内容
 * @param {String} data.order_info.images 图片
 * @return {Promise} 异步返回
 */
export function orderStartBroadcast(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/orderStartBroadcast',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-06-确认开工
 * @method confirmStart
 * @param {Object} data
 * @param {Object} data.order_info 订单信息
 * @param {String} data.order_info.order_id 订单ID
 * @param {String} data.order_info.real_start_time 实际开工日期
 * @return {Promise} 异步返回
 */
export function confirmStart(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/confirmStart',
    method: 'post',
    data
  })
}
/**
 * A-工程交底-06-待开工列表
 * @method orderStartList
 * @param {Object} data
 * @param {Object} data.pagination 分页参数
 * @param {Number | String} data.pagination.page 分页页数
 * @param {Number | String} data.pagination.count 分页大小
 * @param {Object} data.filter 过滤参数
 * @param {String} data.filter.customer 客户名称过滤参数
 * @return {Promise} 异步返回
 */
export function orderStartList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/orderStartList',
    method: 'post',
    data
  })
}
/**
 * B-工程施工-01-获取施工中列表
 * @method getConstructionList
 * @param {Object} data
 * @param {Object} data.pagination 分页参数
 * @param {Number | String} data.pagination.page 分页页数
 * @param {Number | String} data.pagination.count 分页大小
 * @param {Object} data.filter 过滤参数
 * @param {String} data.filter.customer_name 客户名称过滤参数
 * @param {String} data.filter.customer_phone 客户电话过滤参数
 * @return {Promise} 异步返回
 */
export function getConstructionList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/construction/getConstructionList',
    method: 'post',
    data
  })
}
/**
 * B-工程施工-02-获取施工详情
 * @method getConstructionInfo
 * @param {Object} data
 * @param {Object} data.order_info
 * @param {String} data.order_info.order_id 订单ID
 * @return {Promise} 异步返回
 */
export function getConstructionInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/construction/getConstructionInfo',
    method: 'post',
    data
  })
}
/**
 * B-工程施工-03-获取可创建的施工项
 * @method getConstructionInfo
 * @param {Object} data
 * @param {Object} data.order_info
 * @param {String} data.order_info.order_id 订单ID
 * @return {Promise} 异步返回
 */
export function getConstructionItem(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/construction/getConstructionItem',
    method: 'post',
    data
  })
}
/**
 * B-工程施工-04-创建施工项提交
 * @method saveConstructionItem
 * @param {Object} data
 * @param {Object} data.order_info
 * @param {String} data.order_info.order_id 订单ID
 * @param {String} data.order_info.process_id 阶段ID
 * @param {String} data.order_info.content 备注
 * @param {String} data.order_info.images 图片
 * @return {Promise} 异步返回
 */
export function saveConstructionItem(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/construction/saveConstructionItem',
    method: 'post',
    data
  })
}
/**
 * B-工程施工-05-添加施工日报
 * @method saveDayItems
 * @param {Object} data
 * @param {Object} data.order_info
 * @param {String} data.order_info.order_id 订单ID
 * @param {String} data.order_info.process_id 阶段ID
 * @param {String} data.order_info.article_id
 * @param {String} data.order_info.images 图片集
 * @param {String} data.order_info.content 备注
 * @param {String} data.order_info.finish 是否节点完成
 * @return {Promise} 异步返回
 */
export function saveDayItems(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/construction/saveDayItems',
    method: 'post',
    data
  })
}
/**
 * 公共接口-添加在施工地播报
 * @method saveMessage
 * @param {Object} data
 * @param {Object} data.message_info
 * @param {String} data.message_info.order_id 订单ID
 * @param {String} data.message_info.message_type 8001：材料到场 8002：地坪养护 8003：地面干燥 8004：工期变更
 * @param {String} data.message_info.message_title 标题
 * @param {String} data.message_info.images 图片集
 * @param {String} data.message_info.message_description 描述
 * @param {String} data.message_info.content 正文（字符串）
 * @return {Promise} 异步返回
 */
export function saveMessage(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/message/saveMessage',
    method: 'post',
    data
  })
}

// A-v2-工程交底-08-获取工地个数
export function getDiscloseCount(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getDiscloseCount',
    method: 'post',
    data
  })
}
export function getMessageList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/message/getMessageList',
    method: 'post',
    data
  })
}
// E-v2-客诉处理-04-获取客诉个数
export function getOrderComplaintCount(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/getOrderComplaintCount',
    method: 'post',
    data
  })
}
// v2-公共接口-获取员工角色
export function getStaffRole(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/getStaffRoleList',
    method: 'post',
    data
  })
}
// 获取用户信息
export function getStaffDetail(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/staff/staff/getStaffDetail',
    method: 'post',
    data
  })
}

// G-101-获取输单、变更选项
export function getChangeItems(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/order/order/getChangeItems',
    method: 'post',
    data
  })
}
export function getDisclosedList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getDisclosedList',
    method: 'post',
    data
  })
}
export function getMessageInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/message/getMessageInfo',
    method: 'post',
    data
  })
}
// ====================师琼==========================

// E-客诉处理-01-获取待处理订单列表
export function getOrderComplaintList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/getOrderComplaintList',
    method: 'post',
    data
  })
}

// E-客诉处理-02-获取待处理客诉列表
export function getComplaintList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/getComplaintList',
    method: 'post',
    data
  })
}

// E-客诉处理-03-分配客诉
export function assignComplaint(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/assignComplaint',
    method: 'post',
    data
  })
}

// E-客诉处理-04-客诉详情
export function getComplaintInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/getComplaintInfo',
    method: 'post',
    data
  })
}

// E-客诉处理-05-处理客诉
export function completeComplaint(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/completeComplaint',
    method: 'post',
    data
  })
}

// 获取售后工地列表
export function getAfterList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/aftermarket/getAfterList',
    method: 'post',
    data
  })
}

// D-售后工地-02-质保卡详情
export function getWarrantyInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/aftermarket/getWarrantyInfo',
    method: 'post',
    data
  })
}

// D-售后工地-03-保单详情
export function getInsuranceInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/aftermarket/getInsuranceInfo',
    method: 'post',
    data
  })
}

// 公共接口-获取材料到场列表
export function getMaterials(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/article/getMaterials',
    method: 'post',
    data
  })
}

// A-工程交底-01-获取待预约列表
export function getBookingList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getBookingList',
    method: 'post',
    data
  })
}

// G-1302-创建交底邀请函
export function saveConfide(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/order/confide/saveConfide',
    method: 'post',
    data
  })
}

// F-05-反馈订单列表
export function getFeedbackOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getFeedbackOrderList',
    method: 'post',
    data
  })
}

// F-06-反馈订单问题列表
export function getComplaintListFeedback(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintList',
    method: 'post',
    data
  })
}

// F-07-问题处理详情
export function getComplaintInfoFeedback(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/getComplaintInfo',
    method: 'post',
    data
  })
}

// F-08-客诉处理
export function dealComplaint(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/feedback/dealComplaint',
    method: 'post',
    data
  })
}

// 问题选项
export function getFields(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/feedback/getFields',
    method: 'post',
    data
  })
}

// F-04-客户问题反馈
export function addComplaintFeedback(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/feedback/complaint/addComplaint',
    method: 'post',
    data
  })
}

// 1-材料进度统计
export function getPurchaseProgress(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getPurchaseProgress',
    method: 'post',
    data
  })
}

// 1-材料进度统计-订单列表
export function getMaterialProgressOrder(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getMaterialProgressOrder',
    method: 'post',
    data
  })
}

// 10-订单明细
export function getOrderMaterialDetail(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/disclose/getOrderMaterialDetail',
    method: 'post',
    data
  })
}

// C-工地巡检-12-竣工节点增加审核角色展示
export function getApproveNode(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/inspection/getApproveNode',
    method: 'post',
    data
  })
}
